function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m-13.5-7h99v48.2h-99z",
  fill: "none"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#f60"
}, /*#__PURE__*/React.createElement("path", {
  d: "m79.1 25.3c0-1.2-.9-2.1-2.1-2.1s-2.1.9-2.1 2.1.9 2.1 2.1 2.1c1.3 0 2.1-.9 2.1-2.1zm-2.6.1v1.4h-.4v-3.1h1.1c.7 0 1 .3 1 .8 0 .3-.2.6-.5.7.3 0 .4.3.4.7 0 .3.1.7.2.9h-.5c-.1-.3-.1-.7-.2-1s-.2-.4-.5-.4zm.6-.4c.4 0 .6-.2.6-.4s-.1-.4-.6-.4h-.6v.8zm-2.6.3c0-1.5 1.2-2.5 2.6-2.5s2.6 1 2.6 2.5-1.2 2.5-2.6 2.5-2.6-1-2.6-2.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m65.6 27.8-2.9-3.3-2.9 3.3h-6.2l6-6.7-6-6.8h6.4l2.9 3.3 2.9-3.3h6.1l-6 6.7 6.1 6.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41.8 27.8v-21.3h11.8v4.8h-6.8v3h6.8v4.6h-6.8v4.2h6.8v4.7z"
}));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m36.8 6.5v8.7h-.1c-1.1-1.3-2.5-1.7-4.1-1.7-3.3 0-5.7 2.2-6.6 5.2-1-3.2-3.5-5.2-7.3-5.2-3.1 0-5.5 1.4-6.8 3.6v-2.8h-6.2v-3h6.9v-4.8h-12.6v21.3h5.7v-8.9h5.6c-.2.6-.3 1.3-.3 2.1 0 4.4 3.4 7.6 7.7 7.6 3.6 0 6-1.7 7.3-4.8h-4.8c-.7.9-1.2 1.2-2.5 1.2-1.5 0-2.8-1.3-2.8-2.9h9.9c.4 3.5 3.2 6.6 6.9 6.6 1.6 0 3.1-.8 4-2.2h.1v1.4h5v-21.4zm-20.7 12.4c.3-1.4 1.4-2.2 2.7-2.2 1.4 0 2.4.9 2.7 2.2zm17.7 5.7c-1.8 0-3-1.7-3-3.5 0-1.9 1-3.7 3-3.7 2.1 0 2.9 1.8 2.9 3.7 0 1.8-.9 3.5-2.9 3.5z",
  fill: "#46148c"
});
function SvgFedexLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 105,
    width: 240,
    enableBackground: "new 0 0 79.6 34.6",
    viewBox: "0 0 79.6 34.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedexLogo);
export default __webpack_public_path__ + "static/media/fedex-logo.c1d32fa2f66879623f5120699d5f3ae0.svg";
export { ForwardRef as ReactComponent };